import ManaHeader from './components/ManaHeader';
import ManaMenu from './components/ManaMenu';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import contentStyle from '../mana/style/content.module.less';
import Breadcrumb from '../mana/components/Breadcrumb';

const Content = () => {
  const { contentWrapper } = contentStyle;
  return (
    <div className={contentWrapper}>
      <Breadcrumb />
      <Outlet />
    </div>
  );
};

const ManaLayout = () => {
  return (
    <>
      <Layout>
        <Layout.Header
          style={{
            height: '50px', padding: 0,
            lineHeight: 'unset'
          }}
        >
          <ManaHeader />
        </Layout.Header>
        <Layout>
          <Layout.Sider
            theme="light"
            style={{
              height: 'calc(100vh - 50px)'
            }}
          >
            <ManaMenu />
          </Layout.Sider>
          <Layout.Content>
            <Content />
          </Layout.Content>
        </Layout>
      </Layout>
    </>
  );
};

export default ManaLayout;